import { render, staticRenderFns } from "./RelatedProductModal.vue?vue&type=template&id=13ebd4eb&scoped=true&"
import script from "./RelatedProductModal.vue?vue&type=script&lang=ts&"
export * from "./RelatedProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebd4eb",
  null
  
)

export default component.exports